// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".column-charts .recharts-surface {\n  overflow: visible;\n}\n.column-charts .ant-card-body {\n  height: 300px;\n  padding: 2rem 5.5rem;\n}\n.column-charts .ant-card-body text {\n  font-size: 1.3rem !important;\n}\n.column-charts .ant-card-body .recharts-legend-wrapper {\n  bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
